var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Visa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-mastercard-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16,
    rx: 2,
    ry: 2,
    style: {
      fill: "#353a48"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.09,
    cy: 8,
    r: 4.36,
    style: {
      fill: "#e82c30"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8_copy",
    "data-name": "Ellipse 8 copy",
    cx: 15.91,
    cy: 8,
    r: 4.36,
    style: {
      fill: "#eca21d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_25",
    "data-name": "Rounded Rectangle 25",
    d: "M13,4.36h0a4.12,4.12,0,0,0-1.71,5.56,4,4,0,0,0,1.22,1.4l.49.32.05,0a4.1,4.1,0,0,0,1.67-5.53A4.19,4.19,0,0,0,13,4.36",
    style: {
      fill: "#f36d1e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.73f85dd0b6555956852ae457ca0c58b6.svg";
export { ForwardRef as ReactComponent };